import debug from 'debug';
import ComponentStorageBase from 'Global/Shared/Components/ComponentStorage/ComponentStorageBase';
import Utils from 'Global/Shared/Components/Utils/Utils';

const log = debug('Dictionary:DictionaryStorage');
const utils = new Utils();

class DictionaryStorage extends ComponentStorageBase {
	/**
	 * @param {Object} options
	 * @param {string} options.componentKey the component identifier
	 */
	constructor(options) {
		super(options);

		this.sessionKey = 'fkd~dictionary';
		this.initialize();
	}

	load() {
		const data = this.getComponent();
		log('load()', this.componentKey, data);
		return data;
	}

	save(data) {
		const baseData = this.getComponent();
		const mergedData = utils.Extend(baseData, data);

		this.setComponent(mergedData);
	}
}

export default DictionaryStorage;
